import medicationImageUrl from "@/assets/medication.svg"
import BackButton from "@/components/BackButton"
import HeroImage from "@/components/HeroImage"
import Page from "@/components/Page"
import Spinner from "@/components/Spinner"
import { useFinishOnboarding } from "@/util/hooks/useFinishOnboarding"

type MedicationQuestionStepProps = {
  onNext: () => void
  onBack: () => void
}

const choiceClasses = (selected: boolean) =>
  `flex-1 rounded-md border-4 px-4 py-6 text-base font-medium shadow-card transition-colors ${
    selected ? "border-primary bg-secondary" : "border-primary bg-white hover:bg-secondary"
  }`

const MedicationQuestionStep = ({ onNext, onBack }: MedicationQuestionStepProps) => {
  const { finishOnboarding, isPending } = useFinishOnboarding()

  const handleNo = () => {
    finishOnboarding()
  }

  const handleYes = () => {
    onNext()
  }

  return (
    <Page showAppbar={false}>
      <div className="absolute left-4 top-4 z-10">
        <BackButton customClickHandler={onBack} />
      </div>
      <HeroImage src={medicationImageUrl} alt="Medication" />
      <div className="flex min-h-[calc(100vh-40vh-56px)] flex-col justify-between gap-6">
        <div className="flex flex-col gap-6">
          <p className="text-base text-primary-contrast">Do you take any medication?</p>
          <div className="flex gap-3">
            <button
              type="button"
              disabled={isPending}
              onClick={handleYes}
              className={choiceClasses(false)}
            >
              Yes
            </button>
            <button
              type="button"
              disabled={isPending}
              onClick={handleNo}
              className={choiceClasses(false)}
            >
              No
            </button>
          </div>
        </div>
        {isPending && (
          <div className="flex items-center justify-center gap-2">
            <Spinner />
            <span className="text-sm text-primary-contrast/70">Loading...</span>
          </div>
        )}
      </div>
    </Page>
  )
}

export default MedicationQuestionStep
